import './personalPolicy.scss';

const PersonalPolicy = ({content='',  ref1,ref2}:{type: string, content?:string, ref1,ref2}) => {
    return (
        <div>
            <div>
                <div className="weddinghall-policy-wrap" ref={ref1}>
                    <h2>개인정보 수집 및 이용</h2>
                    <p style={{whiteSpace:'pre-line'}}>
                        {content}
                    </p>
                </div>
                <div className="divider" style={{backgroundColor:'#fff', margin:'9px 0'}}/>
                <div className="weddinghall-policy-wrap" ref={ref2}>
                    <h2>개인정보 제3자 제공 동의</h2>
                    <div className='policy-content-wrap'>
                    <p className='bold' style={{fontSize: '15px'}}>1. 개인정보를 제공받는 자 : 웨딩홀</p>
                    <p className="additional">
                        <p>※ 추가 수집하는 필수항목</p>
                        <ul>
                            <li>예약자와 실제 방문자가 다른 경우: 방문자의 이름 및 휴대전화번호</li>
                        </ul>
                    </p>
                    <p>
                        2. 제공하는 기본 개인정보 항목: [필수] 예약자의 이름,
                        (휴대)전화번호, 희망예식정보
                    </p>
                    <p>
                        3. 개인정보를 제공받는 자의 이용목적 : 사업자회원과
                        예약이용자의 원활한 거래 진행, 서비스 분석과 통계에 따른
                        혜택 및 맞춤 서비스 제공, 민원처리 등 고객상담,
                        고객관리, 서비스 이용에 따른 설문조사 및 혜택 제공,
                        분쟁조정을 위한 기록보존
                    </p>
                    <p>
                        4. 개인정보를 제공받는 자의 개인정보 보유 및 이용기간 :
                            위 개인정보 이용목적 달성 시 까지 이용합니다. (단, 관련
                            법령에 따른 보관의무가 있는 경우에 그 기간동안 보관)
                    </p>
                    <p>
                        5. 동의 거부권 등에 대한 고지 : 정보주체는 개인정보 제공
                            동의를 거부할 권리가 있으나, 이 경우 상품 및 서비스
                            예약이 제한될 수 있습니다.
                    </p>
                    </div>
                </div>
                </div>
        </div>
    );
};

export default PersonalPolicy;

